import { TEmployeeRenewVisaDocumentStepGroup } from "@/api/entities/employee-renew-visa-document-step-group.entity";
import { finishSubmitDocumentStepGroupApi } from "@/api/services/main/renew-visa";
import { Button } from "@/components/elements/Button";
import { Linkable } from "@/components/elements/Linkable";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { RenewVisaStepCard } from "@/features/renew-visa/components/RenewVisaStepCard";
import { state, text } from "@/theme/colors";
import { RENEW_VISA_DOCUMENT_STEP_STATUS } from "@/types/enum";
import { showError } from "@/utils/error";
import { openInNewTab } from "@/utils/export";
import { toNumber } from "@/utils/number";
import { Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { FC } from "react";

export type TRenewVisaOnlineSubmitApplicationStepProps = {
  isSkipStep: boolean;
  stepGroupData: TEmployeeRenewVisaDocumentStepGroup;
  readonly: boolean;
  isExistBasicInfoData: boolean;
};

export const RenewVisaOnlineSubmitApplicationStep: FC<TRenewVisaOnlineSubmitApplicationStepProps> = ({
  stepGroupData,
  readonly,
  isSkipStep,
  isExistBasicInfoData,
}) => {
  const { stepName } = stepGroupData.masterDocumentStep;
  const { id: documentStepGroupId } = stepGroupData;

  const queryClient = useQueryClient();

  const handleFinishOnlineSubmitApplication = async () => {
    if (!documentStepGroupId) return;
    try {
      await finishSubmitDocumentStepGroupApi({ documentStepGroupId: toNumber(documentStepGroupId) });
      await queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.RENEW_VISA_DOCUMENTS.FETCH_GROUP_DETAIL] });
      openInNewTab("https://www.rasens-immi.moj.go.jp/rasens-u/offer/offerList_initDisplay");
    } catch (error) {
      showError(error);
    }
  };

  return (
    <RenewVisaStepCard
      isSkip={isSkipStep}
      isCompleted={stepGroupData.status === RENEW_VISA_DOCUMENT_STEP_STATUS.COMPLETE}
      title={`ステップ${isExistBasicInfoData ? stepGroupData.masterDocumentStep.stepOrder : stepGroupData.masterDocumentStep.stepOrder - 1}`}
      subTitle={stepName}
      buttons={
        <Button variant="outline" size="sm" disabled={readonly || isSkipStep} onClick={() => handleFinishOnlineSubmitApplication()}>
          申請
        </Button>
      }
    >
      <Typography component="p" variant="body14" mb="8px" color={text.secondary}>
        「申請」ボタンから在留申請オンラインシステムに移動します。
      </Typography>
      <Linkable href="https://support.iro-hana.com/1ff5d48302ae80428d96dd5eb0c42879" target="_blank" width="170px">
        <Typography variant="link14Semi" color={state.link_1} sx={{ textDecoration: "underline" }}>
          申請フローの詳細はこちら
        </Typography>
      </Linkable>
    </RenewVisaStepCard>
  );
};
